// extracted by mini-css-extract-plugin
export default {"logo":"About_logo__rNWyi","wrapper":"About_wrapper__LGATQ","menu":"About_menu__QIylP","button":"About_button__8pnMF"};